//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constant from '~/const';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      status: '',
      input: {},
      constant,
      statuses: [
        { id: 6, name: 'Cancelled' },
        { id: 5, name: 'Completed' },
      ],
    };
  },

  computed: {
    ...mapState('tradersRequisites', ['userData']),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isApplyPossible() {
      return this.status
      && this.input?.comment;
    },
  },

  methods: {
    apply() {
      this.input.tradeId = this.$props.data.id;
      const { input } = this;
      const status = [];
      if (this.status === 5) {
        status.setCompleted = true;
      } else if (this.status === 6) {
        status.setCancelled = true;
      }
      this.$emit('apply', { input, status });
    },

    getStatus(current) {
      let res;
      switch (current) {
        case 5:
          res = this.statuses.filter((e) => e.id !== current);
          break;
        case 6:
          res = this.statuses.filter((e) => e.id !== current);
          break;
        default:
          res = this.statuses;
          break;
      }
      return res;
    },
  },
};
